import 'normalize.css/normalize.css';
import React from 'react';
import Routing from './routes';
import CustomValidation from 'constants/customValidations';
import validator from 'validate.js'
import HttpClient from 'services/HttpClient';
import {withRouter} from 'react-router-dom';
import {inject} from 'mobx-react';
import AlertContainerWrapper from 'modules/blocks/AlertContainerWrapper'
import Preloader from 'modules/blocks/Preloader'



@withRouter
@inject('userStore')
export default class Main extends React.Component {

  componentWillMount(){
    new CustomValidation(validator);
    new HttpClient().initialize(this.props.history, this.props.userStore);
  }

  render() {
    return(
      <div>
          <AlertContainerWrapper key="alert"/>
          <Preloader key="preloader"/>
          <Routing key="routing"/>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/Main.js